import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcesses(packing_house_id) {
    return RequesterV1.get(
      `packing_house/quality_reports/process/list_processes/${packing_house_id}`
    );
  }
};
